import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import ButtonOptionGroup from '../../component/ButtonOptions/ButtonOption';
import Tab from '../../../../component/Tabs/Tab';
import DataTablePageDynamic from '../../../../component/Table/DataTablePageDynamic';

const Product = () => {
    const navigate = useNavigate();
    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);

    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const [data, setData] = useState([]);
    const [isNextPage, setIsNextPage] = useState(true);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [activeType, setActiveType] = useState("product");
    const tabHeader = [
        {
            "key": "product",
            "label": "Barang & Jasa",
        },
        {
            "key": "warehouse",
            "label": "Gudang"
        }
    ];

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_PRODUCT = "api/erpppsu/product";
    const PATH_WAREHOUSE = "api/erpppsu/warehouse";

    // Fetch data from the API
    const fetchData = async (URL, config) => {
        try {
            const response = await axios.get(URL, config);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (activeType == 'product') {
            fetchData(`${BASE_URL}${PATH_PRODUCT}`, {
                params: {
                    offset: pageIndex,
                    limit: pageSize
                }
            }).then((data) => {
                setData(data.data);
            });
        } else if (activeType == 'warehouse') {
            fetchData(`${BASE_URL}${PATH_WAREHOUSE}`, {
                params: {
                    offset: pageIndex,
                    limit: pageSize
                }
            }).then((data) => {
                setData(data.data);
            });
        }
    }, [activeType]);

    useEffect(() => {
        setKeys(data.length > 0 ? Object.keys(data[0]) : []);
    }, [data]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        })));
    }, [keys]);

    const handleTabClick = (tab) => {
        setActiveType(tab);
    };

    const options = [
        { value: 'add-product', label: 'Tambah Produk Baru' },
        { value: 'add-warehouse', label: 'Tambah Gudang Baru' }
    ];

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <div className='flex items-center justify-between'>
                <h1>Produk</h1>

                <div className='flex items-center'>
                    <ButtonOptionGroup
                        label={"Tindakan"}
                        options={options}
                        onChange={(value) => {
                            if (value == 'add-product') {
                                navigate('/activity-erpppsu/product/new');
                            } else if (value == 'add-warehouse') {
                                navigate('/activity/new-warehouse');
                            }
                        }}
                    />
                </div>
            </div>

            <div className="tabs">
                {tabHeader.map((tab) => (
                    <Tab name={tab.key} label={tab.label} activeTab={activeType} onClick={() => {
                        handleTabClick(tab.key)
                    }} />
                ))}
            </div>

            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                <DataTablePageDynamic
                    data={data}
                    nextPage={isNextPage}
                    columns={columns}
                    elementClass="p-1"
                    actions={[]}
                    onDataChange={(pageIndex, pageSize, sortBy) => {
                        if (activeType == 'product') {
                            fetchData(`${BASE_URL}${PATH_PRODUCT}`, {
                                params: {
                                    offset: pageIndex,
                                    limit: pageSize
                                }
                            }).then((data) => {
                                setIsNextPage(data.more > 0);
                                setData(data.data);
                            });
                        } else if (activeType == 'warehouse') {
                            fetchData(`${BASE_URL}${PATH_WAREHOUSE}`, {
                                params: {
                                    offset: pageIndex,
                                    limit: pageSize
                                }
                            }).then((data) => {
                                setIsNextPage(data.more > 0);
                                setData(data.data);
                            });
                        }
                    }} />
            )}
        </div>
    );
}

export default Product;
